// frontend/admin-portal/src/components/products/ProductStats.jsx
import React, { useEffect, useState } from "react";
import { Card, Title, Spinner } from "@fiberhome/shared-ui";
import { productService } from "../../services/productService";
import { useSettings } from "../../contexts/SettingsContext";

export default function ProductStats({ refreshKey = 0 }) {
  const { get } = useSettings();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const currency = get("finance.currencySymbol", "IQD");

  useEffect(() => {
    let alive = true;
    setLoading(true);
    productService
      .stats()
      .then((s) => alive && setStats(s))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [refreshKey]);

  const cards = [
    { label: "Total Products", value: stats?.total ?? "—", variant: "primary" },
    { label: "Active", value: stats?.active ?? "—", variant: "success" },
    { label: "Low Stock", value: stats?.lowStock ?? "—", variant: "warning" },
    {
      label: "Out of Stock",
      value: stats?.outOfStock ?? "—",
      variant: "danger",
    },
  ];

  return (
    <div className="row g-3 mb-4">
      {cards.map((c) => (
        <div className="col-md-3 col-sm-6" key={c.label}>
          <Card hoverable>
            <div className="text-muted" style={{ fontSize: 12 }}>
              {c.label}
            </div>
            <Title level={2} className="mb-0">
              {loading ? <Spinner size="md" /> : c.value}
            </Title>
          </Card>
        </div>
      ))}
    </div>
  );
}
